import React from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';
import Select from 'react-select';

export const FormPrinterPoint = (props) => {

    const {
        name, username, password, password_confirmation,
        handleInputChange, validaciones, methodAction, button, mSelectBranch, branches, handleSelectValues
    } = props;
    const {
        name: validacionName,
        username: validacionUsername,
        password: validacionPassword,
        password_confirmation: validacionPasswordConfirmation,
        mSelectBranch: validacionBraches,

    } = validaciones;

    return (
        <Form className='pt-3' autoComplete="off" role="form" onSubmit={methodAction}>
            <div className='form-section'>
                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label className="label-admision">Nombre del punto de impresión <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                            <Input
                                type="text"
                                name="name"
                                value={name}
                                required={true}
                                autoComplete="new-password"
                                onChange={handleInputChange}
                                invalid={validacionName}
                                className="input-admision"

                            />
                            <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label className="label-admision">Nombre del usuario <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                            <Input
                                type="text"
                                name="username"
                                value={username}
                                required={true}
                                autoComplete="new-password"
                                onChange={handleInputChange}
                                invalid={validacionUsername}
                                className="input-admision"

                            />
                            <FormFeedback>El nombre de usuario debe tener 3 o más caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label className='label-admision'>Sucursal <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                            <Select
                                name="mSelectBranch"
                                isClearable={true}
                                placeholder="Selecciona una sucursal"
                                options={branches}
                                onChange={(e) => handleSelectValues(e, 'mSelectBranch')}
                                value={mSelectBranch}
                                className="select-branch"
                                required={true}
                                invalid={validacionBraches}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                            />
                            {validacionBraches && (
                                <FormFeedback style={{ display: 'block' }}>
                                    Seleccione una sucursal para el punto de impresión
                                </FormFeedback>
                            )}
                        </FormGroup>

                    </Col>
                </Row>
                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label className="label-admision">Contraseña <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                            <Input
                                type="password"
                                name="password"
                                value={password}
                                required={true}
                                autoComplete="new-password"
                                onChange={handleInputChange}
                                invalid={validacionPassword}
                                className="input-admision"

                            />
                            <FormFeedback>La contraseña debe debe tener 8 o más caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label className="label-admision">Confirmación de contraseñá <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                            <Input
                                type="password"
                                name="password_confirmation"
                                value={password_confirmation}
                                required={true}
                                onChange={handleInputChange}
                                invalid={validacionPasswordConfirmation}
                                className="input-admision"
                                autoComplete="new-password"

                            />
                            <FormFeedback>Las contraseñas no coinciden, por favor verifique su información</FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>
            </div>

        </Form>
    )
}
